module.exports = __webpack_public_path__ + "img/logo-epic.88ea2eee.svg";